import { IContact } from 'clickNgo/entities/contact'
import { IContactFlag } from 'clickNgo/entities/contactFlag'

export type RoleToReassign = { role: string; contact?: IContact | null }
export type FlagToReassign = { flag: IContactFlag; contact?: IContact | null }

export type ContactRolesRemoving = {
  contact: IContact
  rolesForRemoving: string[]
}

export enum RoleReassignmentOption {
  RemoveFromMovingContact = 'remove_from_moving',
  RemoveFromTargetPartnerContacts = 'remove_from_partner_target',
}

export interface ReassignmentItem {
  key: string
  displayName: string
  contact?: IContact | null
}
